/**
 * Canonical PUBLIC policy URLs.
 *
 * The marketing site is the source of truth for policy content — the app never renders it. These must
 * load WITHOUT authentication (the user is being asked to read before they are fully signed in) and must
 * render on mobile.
 *
 * `GET /api/policies/pending` also returns a `canonical_url` per document; prefer that when it is present,
 * because it lets a URL move without a client deploy. These are the fallback, and the only source for
 * unauthenticated surfaces (login, SSO, register, activation, help center) which never call `/pending`.
 *
 * Do NOT hardcode these anywhere else. They were previously duplicated across six templates and drifted.
 */
export const TERMS_OF_SERVICE_URL = 'https://easyeviction.com/terms/';
export const PRIVACY_POLICY_URL = 'https://easyeviction.com/privacy/';
